var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedpushrLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 98.918,
    height: 100,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.371 .286) scale(.57616)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.566,
    cy: 86.286,
    rx: 13.566,
    ry: 13.714,
    style: {
      fill: "#f95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.569 100H46.35c0-25.879-20.752-46.858-46.35-46.858V33.715c36.214 0 65.569 29.676 65.569 66.285z",
    style: {
      fill: "#f95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.135 100c0-44.183-35.429-80-79.135-80V0c54.631 0 98.918 44.772 98.918 100H79.135z",
    style: {
      fill: "#f95"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59f"
    },
    d: "M27.29 48.897h7.086c0 9.541 7.65 17.276 17.088 17.276v7.162c-13.351 0-24.173-10.94-24.173-24.438z",
    transform: "matrix(1.56282 0 0 1.56282 -23.424 -34.32)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59f"
    },
    d: "M22.638 48.625C22.484 64.913 35.42 78.24 51.533 78.39l-.07 7.373c-20.139-.19-36.31-16.848-36.119-37.208l7.294.069z",
    transform: "matrix(1.56282 0 0 1.56282 -23.424 -34.32)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedpushrLogo);
export default __webpack_public_path__ + "static/media/FeedpushrLogo.22d8c77d06946961bc9715b5566e619c.svg";
export { ForwardRef as ReactComponent };